import { render, staticRenderFns } from "./ParagraphCardEdit.vue?vue&type=template&id=2b3bc2f4&scoped=true&"
import script from "./ParagraphCardEdit.vue?vue&type=script&lang=js&"
export * from "./ParagraphCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphCardEdit.vue?vue&type=style&index=0&id=2b3bc2f4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3bc2f4",
  null
  
)

export default component.exports